import { BookingMode } from '../storage';

let session: ISession | null = null;

export const getSession = () => session;
export const setSession = (value: ISession) => { session = value; };

export interface ISession {
    bookingMode: BookingMode;
    hasReturn: boolean;
    noFlight: boolean;

    route1: ISessionRoute;
    route2: ISessionRoute;
}

export interface ISessionRoute {
    fromAddress: API.ApiLocation | null;
    toAddress: API.ApiLocation | null;

    flightNumber: string;
    flightDate: string;

    noflight: {
        from: API.ApiLocation | null,
        to: API.ApiLocation | null,
        dateTime: string
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/session/session-storage.ts